import { type TAgentStatus } from "../types/agent";

export const agentPaths = {
	main: "/agent",
	chat: "/agent/chat/:conversationId",
	sharedChat: "/agent/shared/chat/:conversationId",
};

export const POLLING_STATUS = {
	NOT_YET_STARTED: "NOT_YET_STARTED",
	IN_PROGRESS: "IN_PROGRESS",
	COMPLETED: "COMPLETED",
	ERROR: "ERROR",
};

export const AGENT_MAX_MESSAGES_PER_CHAT = 200;

export const AGENT_QUERY_USAGE_REVEAL_RATIO = 0.1;

// Conversation history is fetched per turn on the backend. Ten turns is the
// current page size for the initial history load and each "load more" action.
export const AGENT_HISTORY_TURN_PAGE_SIZE = 10;

export const AgentStatusMessages: Record<
	TAgentStatus,
	string
> = {
	PENDING:
		"Paul is awaiting instructions and preparing to start its task.",
	PREPARING:
		"Paul is setting up its environment and gathering necessary resources.",
	THINKING:
		"Paul is actively processing information and formulating a plan.",
	EVALUATING:
		"Paul is reviewing its progress and assessing the current state of the task.",
	COMPLETED:
		"Paul has successfully finished its assigned task.",
	DEBUG_PREPARING:
		"Paul is preparing its environment in debug mode to trace execution.",
	DEBUG_THINKING:
		"Paul is processing information in debug mode, step-by-step.",
	DEBUG_EVALUATING:
		"Paul is evaluating its state in debug mode to identify potential issues.",
};
